export default {
  layout: {
    navbarBreakpoint: 1000,
    sidebarWidth: 250
  },
  boxTypes: {
    0: "A",
    1: "B",
    2: "C"
  },
  locationTypes: {
    0: "variables.locations.0",
    1: "variables.locations.1",
    2: "variables.locations.2",
    3: "variables.locations.3"
  },
  roles: {
    2: "variables.roles.admin",
    1: "variables.roles.driver",
    0: "variables.roles.storeman"
  },
  roleName: {
    ADMIN: 2,
    DRIVER: 1,
    STOREMAN: 0
  }
};
